<template>
    <q-card :dark="$q.platform.is.mobile" :class="$q.platform.is.mobile?'bg-black':'bg-white'" :style="$q.platform.is.mobile ? '' : 'min-width: 80vw; min-height: 80vh; max-height: 80vh;'">
        <q-toolbar>
            <q-toolbar-title>{{ $t('ranking') }}</q-toolbar-title>

            <q-btn @click="close_modal" flat round dense icon="fal fa-times" v-close-popup />
        </q-toolbar>

        <q-card-section>
            <div class="row">
                <div class="col-sm-3 col-xs-8">
                    <q-select
                        rounded
                        outlined
                        dense
                        v-model="selected_ranking"
                        :options="ranking_list"
                        @update:model-value="changeRanking"
                        :bg-color="$q.platform.is.mobile?'black':'white'"
                        :dark="$q.platform.is.mobile?true:false"
                    >
                        <template v-slot:selected>
                            {{ $t('show_ranking') }}: {{ selected_ranking.label }}
                        </template>
                    </q-select>
                </div>
            </div>
        </q-card-section>

        <q-card-section v-if="selected_ranking.value === 'all'">
            <q-list>
                <template v-for="(ranking, index) in filteredRanking" :key="index">
                    <q-item
                        clickable
                        v-if="filteredRanking.length > 0"
                        :class="($q.platform.is.mobile?('bg-black text-white'):(index % 2 === 1 ? 'bg-grey-2' : ''))"
                    >
                        <q-item-section side style="width: 35px;">
                            {{ index + 1 }}
                        </q-item-section>

                        <q-item-section avatar>
                            <q-avatar color="primary" text-color="white">
                                <q-img :src="getImage(ranking)" style="height: 2.5rem;">
                                    <template v-slot:error>
                                        <div class="absolute-full flex flex-center bg-primary text-white">
                                            {{ ranking.n.charAt(0).toUpperCase() }}
                                        </div>
                                    </template>
                                </q-img>
                            </q-avatar>
                        </q-item-section>

                        <q-item-section>{{ removeUserEmail(ranking.n) }}</q-item-section>

                        <q-item-section side v-if="ranking.s">
                            {{ getScore(ranking.s) }}
                        </q-item-section>

                        <q-item-section side v-else>
                            {{ getScore(0) }}
                        </q-item-section>
                    </q-item>
                </template>

                <q-item v-if="filteredRanking.length === 0" class="text-grey-9">
                    <q-item-section class="text-body1">
                        {{ $t('your_ranking_position_will_be_available_after_you_complete_at_least_one_course') }}
                    </q-item-section>
                </q-item>
            </q-list>
        </q-card-section>

        <q-card-section v-else>
            <q-list>
                <template v-if="rankings?.length > 0">
                    <q-item clickable v-for="(ranking, index) in rankings" :key="index" class="text-grey-9" :class="index % 2 === 1 ? 'bg-grey-2' : ''">
                        <q-item-section side style="width: 35px;">
                            {{ index + 1 }}
                        </q-item-section>

                        <q-item-section avatar>
                            <q-avatar color="primary" text-color="white" v-if="ranking.image">
                                <q-img :src="ranking.image" style="height: 2.5rem;">
                                    <template v-slot:error>
                                        <div class="absolute-full flex flex-center bg-primary text-white">
                                            {{ ranking.full_name.charAt(0).toUpperCase() }}
                                        </div>
                                    </template>
                                </q-img>
                            </q-avatar>

                            <q-avatar v-else size="2.5rem" color="primary" text-color="white">{{ ranking.full_name.charAt(0).toUpperCase() }}</q-avatar>
                        </q-item-section>

                        <q-item-section>{{ ranking.full_name }}</q-item-section>

                        <q-item-section side v-if="ranking.score">
                            {{ getScore(ranking.score) }}
                        </q-item-section>

                        <q-item-section side v-else>
                            {{ getScore(0) }}
                        </q-item-section>
                    </q-item>
                </template>

                <q-item v-if="rankings.length === 0" class="text-grey-9">
                    <q-item-section class="text-body1">
                        {{ $t('your_ranking_position_will_be_available_after_you_complete_at_least_one_course') }}
                    </q-item-section>
                </q-item>
            </q-list>
        </q-card-section>

        <q-inner-loading :showing="loading">
            <q-spinner-facebook size="1rem" color="text-blue-grey-4" />
        </q-inner-loading>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { db } from 'src/boot/firebase'
import { getAuth } from "firebase/auth"
import { doc, onSnapshot } from "firebase/firestore"

export default {
    name: 'Ranking',

    props: ['ranking_list', 'close_modal'],

    data() {
        return {
            document: '',
            has_next_page: true,
            page: 1,
            page_size: 50,
            rankings: [],
            selected_ranking: {
                label: this.$t('general'),
                value: 'all'
            },
            user_position: null,
            loading: false
        }
    },

    computed: {
        ...mapGetters({
            id: 'common/id',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            user_firebase_document: 'common/user_firebase_document'
        }),

        filteredRanking() {
            let ranking_ordered = []

            if (this.rankings?.users?.length) {
                ranking_ordered = this.rankings.users.sort((a,b) => (parseFloat(a.s) < parseFloat(b.s)) ? 1 : ((parseFloat(b.s) < parseFloat(a.s)) ? -1 : 0))

                let obj = ranking_ordered.find((obj) => { return obj.i === this.id })
                if (obj) {
                    this.user_position = obj
                    let pos = this.rankings.users.map((e) => { return e.i }).indexOf(this.user_position.i)
                    if (pos > 4) this.user_position.pos = pos
                    else this.user_position = null
                }
                else this.user_position = null

                return ranking_ordered.map(e => ({...e, image_error: false}))
            }
            else return []
        }
    },

    methods: {
        changeRanking() {
            this.ranking = []
            if (this.selected_ranking.value !== 'all') {
                this.has_next_page = true
                this.page = 1
                this.getRanking()
            }
            else {
                this.getFirebaseRanking()
            }
        },

        getRanking() {
            if (this.has_next_page) {
                this.loading = true

                let data = {
                    'page_size': this.page_size,
                    'page': this.page,
                }

                this.$axios.get(`/etraining_ranking/ranking/${this.selected_ranking.value}/?` + this.$qs.stringify(data))
                .then(response => {
                    this.rankings = response.data?.results.length ? response.data.results.map(e => ({...e, i: e.user_id})) : []

                    if (!response.data.next) this.has_next_page = false
                    else this.page++
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.loading = false
                })
            }
        },

        getImage(ranking) {
            return `${process.env.BUCKET_URL}media/users/${ranking.i}/images/50x50.jpg`
        },

        getScore(score) {
            let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

            if (client && client.ranking_use_decimal) return score.toFixed(2)
            else return score.toFixed(0)
        },

        removeUserEmail(name) {
            return name.indexOf('(') !== -1 ? name.slice(0, name.indexOf('(')) : name
        },

        getFirebaseRanking() {
            if (this.user_firebase_document) {
                getAuth()
                onSnapshot(doc(db, "ranking", `${this.user_firebase_document}`), (doc) => {
                    this.rankings = doc.data() ? doc.data() : []
                })
            }
        }
    },

    created() {
        this.getFirebaseRanking()
    }
}
</script>

<style>

</style>
